import { render, staticRenderFns } from "./DeviceTest.vue?vue&type=template&id=647c9007&scoped=true&"
import script from "./DeviceTest.vue?vue&type=script&lang=js&"
export * from "./DeviceTest.vue?vue&type=script&lang=js&"
import style0 from "./DeviceTest.vue?vue&type=style&index=0&id=647c9007&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "647c9007",
  null
  
)

export default component.exports